import { Link } from "react-router-dom";
import type { Film } from "@/types";
import FilmCard from "@/components/feature/FilmCard";

interface SectionProps {
  title: string;
  subtitle: string;
  films: Film[];
  moreHref?: string;
  moreLabel?: string;
}

export default function FilmSection({ title, subtitle, films, moreHref, moreLabel }: SectionProps) {
  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="mb-5 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 text-lg font-extrabold text-foreground-950 md:text-2xl font-heading">
            <span className="h-5 w-1 rounded-full bg-accent-500 md:h-6"></span>
            {title}
          </h2>
          <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>
        </div>
        {moreHref && (
          <Link
            to={moreHref}
            className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200 md:text-sm"
          >
            {moreLabel ?? "查看全部"}
            <i className="ri-arrow-right-s-line text-base"></i>
          </Link>
        )}
      </div>

      {films.length === 0 ? (
        <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-background-300 bg-background-100 py-14 text-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-200 text-foreground-400">
            <i className="ri-inbox-line text-2xl"></i>
          </span>
          <p className="text-sm text-foreground-500">暂无相关内容</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {films.map((film) => (
            <FilmCard key={film.id} film={film} />
          ))}
        </div>
      )}
    </section>
  );
}